import { api } from '@/services/api'
import { apiWeb } from '@/services/api'

export const enviarCorreoCotizacion = async (body, token) => {
  try {
    const response = await api.post('/Cotizacion/EnviarEmail', body, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })

    if (response.status === 200) {
      console.log('Correo enviado correctamente')
    } else {
      console.error('Error al enviar correo', response.data)
    }
  } catch (error) {
    console.error('Error de red al enviar correo', error)
  }
}

export const enviarMensajeFooter = async (datosContacto) => {
  try {
    const response = await apiWeb.post('api/Contacto/enviar-mensaje-footer', datosContacto)

    if (response.status === 200 && response.data.success) {
      return { success: true, message: response.data.message }
    } else {
      return {
        success: false,
        message: response.data?.message || 'Error al enviar mensaje'
      }
    }
  } catch (error) {
    console.error('Error de red al enviar mensaje', error)
    return {
      success: false,
      message: error.response?.data?.message || 'Error de conexión. Intente más tarde.'
    }
  }
}
